export default {
  form: {
    tax_id: {
      label: 'Numéro fiscal',
      placeholder: 'Saisir le numéro fiscal',
    },
    has_vat: {
      label: 'Votre entreprise est-elle assujettie à la TVA ?',
    },
    vat_id: {
      label: 'TVA',
      placeholder: 'TVA',
      tooltip: 'Un numéro de TVA est un identifiant fiscal unique pour votre entreprise',
    },
    tax_percentage: {
      label: 'Taux de taxe',
      placeholder: 'Taux de taxe',
    },
    has_dedicated_products_tax: {
      label: 'Le taux de taxe varie selon le produit',
    },
  },
  buttons: {
    next: 'Suivant',
    back: 'Retour',
    skip: 'Passer',
  },
};
